import { get, mixin } from "../../css/util";

import NavLink from "react-router-dom/NavLink";
import styled from "styled-components";

export const Button = styled.button`
  ${get("style.link")};
  ${mixin("font.bold", 12)};
  background: transparent 3px center / 14px 14px url("/images/back-arrow.svg")
    no-repeat;
  color: ${get("color.link.normal")};
  cursor: pointer;
  display: inline-block;
  line-height: 16px;
  padding-left: 24px;
  text-decoration: none;
  text-transform: uppercase;
  transition: all ${get("transition.link")};
  vertical-align: middle;

  &:hover {
    background-position: 0px center;
  }

  &.active {
    color: ${get("color.link.normal")};
  }
`;

export const Link = Button.withComponent(NavLink);
